import { render, staticRenderFns } from "./inquirycenter.vue?vue&type=template&id=76632195&scoped=true"
import script from "./inquirycenter.vue?vue&type=script&lang=js"
export * from "./inquirycenter.vue?vue&type=script&lang=js"
import style0 from "./inquirycenter.vue?vue&type=style&index=0&id=76632195&scoped=true&lang=css"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&external"
import style2 from "./inquirycenter.vue?vue&type=style&index=2&id=76632195&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76632195",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76632195')) {
      api.createRecord('76632195', component.options)
    } else {
      api.reload('76632195', component.options)
    }
    module.hot.accept("./inquirycenter.vue?vue&type=template&id=76632195&scoped=true", function () {
      api.rerender('76632195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inquirycenter/inquirycenter.vue"
export default component.exports